import { render, staticRenderFns } from "./CartCrossSell.vue?vue&type=template&id=7a894623&"
import script from "./CartCrossSell.vue?vue&type=script&lang=js&"
export * from "./CartCrossSell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/guave/madamesumcontao/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7a894623')) {
      api.createRecord('7a894623', component.options)
    } else {
      api.reload('7a894623', component.options)
    }
    module.hot.accept("./CartCrossSell.vue?vue&type=template&id=7a894623&", function () {
      api.rerender('7a894623', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/madamesum/js/components/CartCrossSell.vue"
export default component.exports